import { createFileRoute, notFound } from '@tanstack/react-router';
import { useRef, useState } from 'react';

import { Terminal as TerminalIcon } from 'lucide-react';

import { ChatPane } from '../components/ChatPane';
import { chatKey, useAppStore } from '../store';
import type { LayoutMode } from '../types';

export const Route = createFileRoute('/chats/$chatId')({
    component: ChatRoute,
});

function ChatRoute() {
    const { chatId } = Route.useParams();
    const chatsByHost = useAppStore((s) => s.chatsByHost);
    const messagesByChat = useAppStore((s) => s.messagesByChat);
    const approveTool = useAppStore((s) => s.approveTool);
    const denyTool = useAppStore((s) => s.denyTool);
    const sendMessage = useAppStore((s) => s.sendMessage);

    const entry = Object.entries(chatsByHost).find(([, list]) => list.some((c) => c.id === chatId));
    if (!entry) throw notFound();
    const [hostId] = entry;
    const key = chatKey(hostId, chatId);
    const messages = messagesByChat[key] ?? [];

    const [layoutMode, setLayoutMode] = useState<LayoutMode>('chat');
    const [splitRatio, setSplitRatio] = useState(0.5);
    const splitRef = useRef<HTMLDivElement>(null);

    const onResizerDown: React.PointerEventHandler<HTMLDivElement> = (e) => {
        const el = splitRef.current;
        if (!el) return;
        const target = e.currentTarget;
        target.setPointerCapture(e.pointerId);
        target.dataset.dragging = 'true';
        const move = (ev: PointerEvent) => {
            const r = el.getBoundingClientRect();
            let frac = (ev.clientX - r.left) / r.width;
            frac = Math.max(0.22, Math.min(0.82, frac));
            setSplitRatio(frac);
        };
        const up = () => {
            try {
                target.releasePointerCapture(e.pointerId);
            } catch {
                /* noop */
            }
            delete target.dataset.dragging;
            window.removeEventListener('pointermove', move);
            window.removeEventListener('pointerup', up);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
    };

    // const splitStyle =
    //   layoutMode === "split"
    //     ? {
    //         gridTemplateColumns: `${(splitRatio * 100).toFixed(2)}% 6px ${((1 - splitRatio) * 100).toFixed(2)}%`,
    //       }
    //     : undefined;

    return (
        <div className="flex flex-col h-full">
            <ChatPane
                messages={messages}
                onApprove={(mId, tId) => approveTool(key, mId, tId)}
                onDeny={(mId, tId) => denyTool(key, mId, tId)}
                onSend={(text) => sendMessage(key, text)}
            />

        </div>
    );
}
